module.exports = __webpack_public_path__ + "static/media/SmartTruck_Vertical_App.587de731.png";